<template>
    <div class="wizard-steps" v-if="showCurrentStep">
        <div class="wizard-step-container container">
            <div class="row">
                <div class="wizard-step">
                    <div class="wizard-step-tracker">
                        <div class="wizard-step-tracker-complete" v-if="showComplete"></div>
                        <ul class="wizard-step-tracker-items" v-if="!showComplete">
                            <li v-for="(step, index) in steps" v-bind:class="currentStepCount >= step ? 'completed' : ''">{{ step }}</li>
                        </ul>
                    </div>
                    <div class="wizard-step-headline" v-html="currentStep.headline"></div>

                    <ul class="wizard-step-actions">
                        <li v-for="(step, index) in currentStep.options">
                            <a class="wizard-step-btn-link" v-bind:href="step.url" v-if="step.isLink">
                                {{ step.label }}
                            </a>
                            <span class="wizard-step-btn" v-on:click="showSubStep(index, $event)" v-else>
                                {{ step.label }}
                            </span>
                        </li>
                    </ul>
                    <div class="wizard-step-close" v-on:click="closeWizard"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="wizard-navigation-wrapper" v-if="showWizard">
        <div class="container">
            <div class="row">
                <div class="wizard-navigation col-12">
                    <div class="wizard-navigation-title" v-html="wizard.headline"></div>
                    <div class="wizard-navigation-items">
                        <ul>
                            <li class="wizard-navigation-item--green wizard-navigation-item" v-for="(option, index) in wizard.options">
                                <a href="#" v-on:click="showStep(index, $event)">{{ option.label }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                currentStep: null,
                currentStepCount: 0,
                showComplete: false,
                showCurrentStep: false,
                showWizard: false,
                steps: 3,
                wizard: window.CFCU.wizard,
            }
        },
        mounted() {
            if (this.wizard !== null && this.wizard !== undefined) {
                this.showWizard = true;

                // Add class to hero
                document.querySelector('.hero').classList.add('hero--wizard');
            }
        },
        methods: {
            adjustHeroHeight() {
                document.querySelector('.hero').style.removeProperty('height');

                this.$nextTick(() => {
                    // Mobile - adjust hero height
                    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                    const wizardStepHeight = document.querySelector('.wizard-step').offsetHeight + 250;

                    if (viewportWidth < 768) {
                        document.querySelector('.hero').style.height = `${wizardStepHeight}px`;
                    }
                });

            },
            closeWizard() {
                this.currentStep = null;
                this.currentStepCount = 0;
                this.showCurrentStep = false;
                this.steps = 3;

                document.querySelector('.hero').removeAttribute('style');
            },
            showStep(index, event) {
                event.preventDefault();
                let loginDropdown = document.querySelector('.login-dropdown');
                loginDropdown.classList.remove('active');

                this.steps = 3;
                this.currentStepCount = 1;
                this.currentStep = this.wizard.options[index];
                this.showCurrentStep = true;
                this.showComplete = false;

                // Jump to hero
                window.scrollTo({
                    behavior: 'smooth',
                    top: 0
                });

                this.adjustHeroHeight();
            },
            showSubStep(index, event) {
                event.preventDefault();
                this.currentStepCount += 1;
                this.showComplete = true;

                this.currentStep = this.currentStep.options[index];
                this.showCurrentStep = true;

                if (this.currentStep.hasChildren) {
                    this.currentStep.options.forEach((option, index) => {
                        if (option.hasChildren) {
                            this.showComplete = false;

                            if (this.currentStepCount === this.steps) {
                                this.steps += 1;
                            }
                        }
                    });
                }

                this.adjustHeroHeight();
            },
        }
    }
</script>